import React, { SFC } from "react";
import { BugerlijkeStaatField } from "./types";
import { useField } from "formik";
import { useExclusiveField } from "./useExclusiveField";

export interface Props {
  parentField: BugerlijkeStaatField;
  field: BugerlijkeStaatField;
  level?: number;
}

export const SubCheckboxField: SFC<Props> = ({ level = 1, field, parentField }) => {
  const [{ value: parentFieldValue }] = useField(parentField.name);
  const { value, onChange } = useExclusiveField(
    field.name,
    parentField.children!.map((c) => c.name)
  );
  const [, , { setValue }] = useField(field.name);

  React.useEffect(() => {
    if (!parentFieldValue && value) {
      setValue(undefined);
    }
  }, [parentFieldValue, setValue, value]);

  const subCheckboxes = React.useMemo(() => {
    return (
      field.children &&
      field.children.map((child) => (
        <SubCheckboxField key={child.name} field={child} parentField={field} level={level + 1} />
      ))
    );
  }, [field, level]);

  if (!parentFieldValue) {
    return <>{subCheckboxes}</>;
  }

  return (
    <div className={`sub${level}`}>
      <input
        className={`bs${level}sub`}
        type="checkbox"
        id={field.name}
        name={field.name}
        checked={!!value}
        onChange={onChange}
      />
      <label className="checkboxlabel" htmlFor={field.name}>
        {field.label}
      </label>
      {subCheckboxes}
    </div>
  );
};

SubCheckboxField.displayName = "SubCheckboxField";
